import { useTranslate } from "react-admin";

const Title = ({ resource, ...props }) => {
  const translate = useTranslate();
  return `Rapidobject Auftragssteuerung: ${translate(`resources.${resource}.name`, 1)} #${props.record.__id}`;
};

export default Title;
